import { memo } from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Badge from '@mui/material/Badge'
import Drawer from '@mui/material/Drawer'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Tooltip from '@mui/material/Tooltip'
import Checkbox from '@mui/material/Checkbox'
import IconButton from '@mui/material/IconButton'
import FormControlLabel from '@mui/material/FormControlLabel'
import {
  faBarsFilter,
  faClose,
  faRotateRight
} from '@fortawesome/pro-duotone-svg-icons'

import { Scrollbar } from 'src/components/scrollbar'
import Text from '../text/Text'
import FaIcon from '../shared/faIcon/FaIcon'
import { MAX_CATEGORIES_FOR_FILTER } from '../../constants/cashback'

const CashbackFilters = ({
  t,
  filterCategories,
  checkedCategoriesForFilter,
  onListItemClick,
  open,
  canReset,
  onOpen,
  onClose,
  onClearAll
}) => {
  const renderHead = () => (
    <>
      <Box
        sx={{
          py: 2,
          pr: 1,
          pl: 2.5,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Text variant='h6' sx={{ flexGrow: 1 }} label={t('common.filter')} />
        <Tooltip title={t('common.clear-all')}>
          <IconButton onClick={onClearAll} disabled={!canReset}>
            <Badge color='error' variant='dot' invisible={!canReset}>
              <FaIcon
                icon={faRotateRight}
                size='sm'
                sx={{ width: 36, height: 36 }}
              />
            </Badge>
          </IconButton>
        </Tooltip>

        <IconButton onClick={onClose} sx={{ width: 36, height: 36 }}>
          <FaIcon icon={faClose} size='sm' />
        </IconButton>
      </Box>

      <Divider sx={{ borderStyle: 'dashed' }} />
    </>
  )

  const renderEmploymentTypes = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Stack
        spacing={1}
        alignItems='center'
        direction='row'
        sx={{ mb: 1 }}
        justifyContent='space-between'
      >
        <Text
          variant='subtitle2'
          label={`${t('common.category')} (${t('common.max')} ${MAX_CATEGORIES_FOR_FILTER})`}
        />
        {canReset > 0 && <Text variant='subtitle2' label={canReset} />}
      </Stack>
      {filterCategories?.map(({ seoFriendlyId, name }, index) => (
        <FormControlLabel
          key={index}
          control={
            <Checkbox
              checked={checkedCategoriesForFilter?.[seoFriendlyId] || false}
              onChange={() =>
                canReset !== MAX_CATEGORIES_FOR_FILTER ||
                checkedCategoriesForFilter?.[seoFriendlyId]
                  ? onListItemClick(seoFriendlyId)
                  : null
              }
            />
          }
          label={name}
        />
      ))}
    </Box>
  )

  return (
    <>
      <Button
        disableRipple
        color='inherit'
        endIcon={
          <Badge color='error' variant='dot' invisible={!canReset}>
            <FaIcon icon={faBarsFilter} />
          </Badge>
        }
        onClick={onOpen}
      >
        {t('common.filter')}
      </Button>

      <Drawer
        anchor='right'
        open={open}
        onClose={onClose}
        slotProps={{ backdrop: { invisible: true } }}
        PaperProps={{ sx: { width: 320 } }}
      >
        {renderHead()}
        <Scrollbar sx={{ px: 2.5, py: 3 }}>
          <Stack spacing={3}>{renderEmploymentTypes()}</Stack>
        </Scrollbar>
      </Drawer>
    </>
  )
}

export default memo(CashbackFilters)
